<template>
  <div id="logo">
    <div id="loading"><img src="./../assets/loading.gif" alt="" /></div>
  </div>
</template>

<script>
import axios from 'axios'

const endpoint = '/api/v2/alive'

export default {
  name: 'Redirector',
  data () {
    return {
      domains: []
    }
  },
  async mounted () {
    await this.init()
    try {
      const response = await this.findDomain()
      if (response && response.config && response.config.url) {
        const domain = response.config.url.replace(endpoint, '')
        const url = this.buildUrl(domain)
        document.location = url
      }
    } catch (e) {
    }
  },
  methods: {
    async init () {
      try {
        const response = await axios.get('/domains.json')
        if (response.data && response.data.domains) {
          this.domains = this.shuffle(response.data.domains)
        }
      } catch (e) {
      }
    },
    parseQuery () {
      return document.location.search.substring(1).split('&').reduce((a, v) => { const p = v.split('='); a[p[0]] = p[1]; return a }, {})
    },
    buildUrl (domain) {
      const params = this.parseQuery()
      const uri = params.l ? '/' + params.l : ''
      const query = Object.keys(params).filter(key => key !== 'l').map(key => key + '=' + params[key]).join('&')
      return domain + uri + (query.length > 0 ? '?' + query : '')
    },
    async findDomain () {
      const requests = []
      const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
      for (const domain of this.domains) {
        const url = this.getUrl(domain, endpoint)
        const request = axios.get(url, config)
        requests.push(request)
      }

      const invert = p => new Promise((resolve, reject) => p.then(reject, resolve))
      const firstOf = ps => invert(Promise.all(ps.map(invert)))

      return firstOf(requests)
    },
    getUrl (domain, endpoint = '') {
      if (domain.indexOf('://') === -1) return `https://${domain}${endpoint}`
      return `${domain}${endpoint}`
    },
    shuffle (a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
      }
      return a
    }
  }
}
</script>

<style>
  body {
    background-color: #000;
    overflow: hidden;
  }

  #logo {
    width: 876px;
    height: 164px;
    display:block;
    margin:auto;
    padding-top:200px;
    background: url(./../assets/logo.jpg) no-repeat bottom center;
  }

  #loading {
    width: 336px;
    margin: auto;
    padding-top: 200px;
  }
</style>
